import { HeroIcon } from '@components/HeroIcon'
import { View, Text, XStack } from 'tamagui'
import { Button } from '@components/Button'
import { useCallback, useMemo } from 'react'

interface IActivityHeaderProps {
  onPreviousPress?: () => void
  onNextPress?: () => void
  hasPreviousContent?: boolean
  hasNextContent?: boolean
  isLoading?: boolean
}

export function ActivityHeader({
  onPreviousPress,
  onNextPress,
  hasPreviousContent,
  hasNextContent,
  isLoading,
}: IActivityHeaderProps) {
  const handlePreviousPress = useCallback(() => {
    if (hasPreviousContent && onPreviousPress) {
      onPreviousPress()
    }
  }, [hasPreviousContent, onPreviousPress])

  const disableNextButton = useMemo(() => {
    return isLoading || !hasNextContent
  }, [isLoading, hasNextContent])

  const disablePreviousButton = useMemo(() => {
    return isLoading || !hasPreviousContent
  }, [isLoading, hasPreviousContent])

  const handleNextPress = useCallback(() => {
    if (hasNextContent && onNextPress) {
      onNextPress()
    }
  }, [hasNextContent, onNextPress])
  return (
    <XStack justifyContent="space-between">
      <Button
        link
        p={0}
        onPress={handlePreviousPress}
        disabled={disablePreviousButton}
      >
        <View
          flexDirection="row"
          alignItems="center"
          gap="$spacing-inset-quarck"
        >
          <View p="$spacing-inset-xs">
            <HeroIcon
              icon={['fas', 'angle-left']}
              size={16}
              color="$icon-secondary"
            />
          </View>
          <Text
            ff="$mulishSemiBold"
            fontSize="$font-size-xs"
            color="$text-secondary"
          >
            Anterior
          </Text>
        </View>
      </Button>
      <Button link p={0} onPress={handleNextPress} disabled={disableNextButton}>
        <View
          flexDirection="row"
          alignItems="center"
          gap="$spacing-inset-quarck"
        >
          <Text
            ff="$mulishSemiBold"
            fontSize="$font-size-xs"
            color="$text-secondary"
          >
            Próximo
          </Text>
          <View p="$spacing-inset-xs">
            <HeroIcon
              icon={['fas', 'angle-right']}
              size={16}
              color="$icon-secondary"
            />
          </View>
        </View>
      </Button>
    </XStack>
  )
}
